export default __webpack_public_path__ + "static/media/kbank.4f3ebe9b.svg";